export default {"src":"/_next/static/media/up-arrow.9a1e333f.svg","height":7,"width":10,"blurWidth":0,"blurHeight":0};